import { cn } from '@/utils';
import * as React from 'react';

const Input = React.forwardRef(({ className, type, ...props }, ref) => {
    return (
        (<input
            className={cn(
                `tw-mt-0 tw-flex tw-h-10 tw-w-full tw-rounded-md
                tw-border tw-border-input
                tw-bg-background tw-px-3 tw-py-2 tw-text-sm tw-ring-offset-background
                file:tw-border-0 file:tw-bg-transparent file:tw-text-sm file:tw-font-medium file:tw-text-foreground
                placeholder:tw-text-muted-foreground
                focus-visible:tw-border-slate-400 focus-visible:tw-ring-0 focus-visible:tw-ring-offset-0
                disabled:tw-cursor-not-allowed disabled:tw-opacity-50`,
                className
            )}
            ref={ref}
            type={type}
            {...props}
        />)
    );
});
Input.displayName = 'Input';

export { Input };
